import React from "react";
import classNames from "classnames";
import "./subscribeIcon.css";

const SubscribeIcon = (props) => {
  const { style, subscribed, disabled, circle, id } = props;
  return (
    <i
      id={id}
      style={style}
      className={classNames("subscribe-icon", "fas", {
        "fa-bell": !circle,
        "fa-circle": circle,
        subscribed: subscribed,
        disabled: disabled,
      })}
    />
  );
};

export default SubscribeIcon;
